import { managerV1BaseUrl } from '@/utils';
import { useEffect } from 'react';

export function NavigateToV1() {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <></>;
}
